/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/aria-proptypes */

import React from 'react';
import PropTypes from 'prop-types';
import { ServicingSection } from 'web-ui-components/lib/global/layout';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { ShellInnerSpacer } from 'web-ui-components/lib/layout/shells';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { fromAccountPropType } from '../../../../states/accounts/propTypes';
import { payeePropTypes } from '../../../../sharedComponents/FromToPayeeSelector/propTypes';

import { FromAccount } from '../../../../sharedComponents/FromAccount/FromAccount';
import { ToAccount } from '../../../../sharedComponents/ToAccount/ToAccount';
import CurrencyAmountField from '../CurrencyAmountField/CurrencyAmountField';
import { style, topBar } from './FromToCurrencySection.style';
import { CONST_COLLECTION } from '../../../../config/constants';

export const FromToCurrencySection = ({
	fromAccount,
	toAccount,
	fromAccounts,
	toPayees,
	sendCurrency,
	handleClose,
	creditAmount,
	showAmountField = true,
	paymentMode,
	isPaymentFlow,
}) => {
	if (!isPaymentFlow) {
		return null;
	}
	const fromTitle = paymentMode === CONST_COLLECTION ? 'To' : 'From';
	const toTitle = paymentMode === CONST_COLLECTION ? 'From' : 'To';
	return (
		<ServicingSection padded={false}>
			<div style={topBar}>
				<Inline.LeftAligned
					nodes={[
						<ShellInnerSpacer>
							<FromAccount
								id="fromAccount"
								fromAccount={fromAccount}
								fromAccounts={fromAccounts}
								disable
								handleSelectFromAccount={() => {}}
								handleCardClick={() => {}}
								title={fromTitle}
							/>
						</ShellInnerSpacer>,
						<ShellInnerSpacer>
							<ToAccount
								id="toAccount"
								showAccountSelector={false}
								toPayees={toPayees}
								fromAccount={fromAccount}
								toAccount={toAccount}
								disable
								handleCardClick={() => {}}
								title={toTitle}
							/>
						</ShellInnerSpacer>,
						showAmountField && (
							<ShellInnerSpacer>
								<CurrencyAmountField
									currencyCode={sendCurrency}
									isDisabled
									amount={creditAmount}
									handleOnChange={() => {}}
									id="CurrencyAmountField"
								/>
							</ShellInnerSpacer>
						),
						<ShellInnerSpacer>
							<div
								id="close-payment-details"
								style={style}
								role="button"
								onClick={handleClose}
								data-cy="close-payment-details"
							>
								<Icon style={style} iconType="CrossSolidSmall" />
							</div>
						</ShellInnerSpacer>,
					]}
				/>
			</div>
		</ServicingSection>
	);
};

export default FromToCurrencySection;

FromToCurrencySection.propTypes = {
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	fromAccount: PropTypes.string.isRequired,
	toAccount: PropTypes.string.isRequired,
	handleClose: PropTypes.func.isRequired,
	sendCurrency: PropTypes.string,
	creditAmount: PropTypes.string,
	showAmountField: PropTypes.bool,
	isPaymentFlow: PropTypes.bool,
	paymentMode: PropTypes.string,
};
